/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdentityWithCredentials } from './identityWithCredentials';


/**
 * Update Identity Body
 */
export interface UpdateIdentityBody { 
    credentials?: IdentityWithCredentials;
    /**
     * Store metadata about the user which is only accessible through admin APIs such as `GET /admin/identities/<id>`.
     */
    metadata_admin?: any | null;
    /**
     * Store metadata about the identity which the identity itself can see when calling for example the session endpoint. Do not store sensitive information (e.g. credit score) about the identity in this field.
     */
    metadata_public?: any | null;
    /**
     * SchemaID is the ID of the JSON Schema to be used for validating the identity\'s traits. If set will update the Identity\'s SchemaID.
     */
    schema_id: string;
    /**
     * State is the identity\'s state. active StateActive inactive StateInactive
     */
    state: UpdateIdentityBody.StateEnum;
    /**
     * Traits represent an identity\'s traits. The identity is able to create, modify, and delete traits in a self-service manner. The input will always be validated against the JSON Schema defined in `schema_id`.
     */
    traits: object;
}
export namespace UpdateIdentityBody {
    export type StateEnum = 'active' | 'inactive';
    export const StateEnum = {
        Active: 'active' as StateEnum,
        Inactive: 'inactive' as StateEnum
    };
}


